import React, { Component, Fragment } from "react";

import config from "./../../config";
import tooltips from "../../tooltips";

import { observer } from "mobx-react";

import {
    Empty,
    List,
    Button,
    Typography,
    Input,
    Pagination,
    Row,
    Col,
    Tooltip,
    Modal,
    Icon,
    Checkbox,
} from "antd";

import CompetitorsListModal from "./CompetitorsListModal";
import Bulk from "./../Bulk";
import scss_variables from "./../../_variables.scss";
import SocialListHeader from "../SocialListHeader";
import SocialListColumn from "../SocialListColumn";

const { Title } = Typography;
const { Search } = Input;
const { confirm } = Modal;

class CompetitorsList extends Component {
    listBulk = null;

    constructor(props) {
        super(props);
        this.state = {
            filter: "",
            //edit_data: {},
            pagination_currentPage: 1,
            sortby: "name",
            sortasc: true,
        };
    }

    UNSAFE_componentWillMount() {
        this.props.store.setCurrentSection("competitors");

        // Breadcrumbs
        // this.props.store.setBreadcrumbs([
        //     { route: `/dashboard/competitors`, title: "Competitors" },
        // ]);
    }
    componentDidMount() {
        //console.info("componentDidMount this.state.info", this.state.info);
        // Bulk listing
        this.listBulk = new Bulk({
            name: "competitorsList",
            list: this.props.store.getAllCompetitors.map(
                (element) => element.key
            ),
            component: this,
            actions: [
                {
                    key: "delete",
                    title: "Delete selected",
                    icon: <Icon type="delete" />,
                    function: async (_key) => {
                        console.log("Action _key=" + _key);
                        await this.props.store.deleteCompetitor({ key: _key });
                    },
                    confirm: "Do you want to delete the selected elements?",
                },
                {
                    key: "report",
                    title: "Report selected",
                    icon: <Icon type="pie-chart" />,
                    function: async (_key) => {
                        console.log("Report _key=" + _key);
                        //await this.props.store.deleteTag(_key);
                    },
                    combined: true,
                },
            ],
            callback: () => {
                console.log("READY");
            },
        });
    }

    componentWillUnmount() {
        //this.props.store.unbindAccountsCollection();
        this.props.store.unregisterModalListener("competitors_modal_add");
    }

    showModal = () => {
        console.log("showModal");
        this.setState({
            edit_data: {},
        });

        this.props.store.showModalByKey("competitors_modal_add");
    };
    showModalForEdit = (_evt, _competitor) => {
        console.info("showModalForEdit _evt", _evt, "_competitor", _competitor);

        this.setState({
            edit_data: _competitor,
        });

        this.props.store.showModalByKey("competitors_modal_add");
    };

    setSorting = (_sorting) => {
        console.info("setSorting _sorting", _sorting);
        let { sortby, sortasc } = this.state;

        if (sortby === _sorting) {
            sortasc = !sortasc;
        } else {
            sortasc = true;
        }

        console.info("sortby", sortby, "sortasc", sortasc);
        this.setState({ sortby: _sorting, sortasc });
    };

    handleDeleteCompetitor = (_evt, _item) => {
        console.info("handleDeleteCompetitor _evt", _evt, "_item", _item);

        let that = this;
        confirm({
            title: "Are you sure you want to delete this?",
            okType: "danger",
            onOk() {
                that.props.store.deleteCompetitor(_item);
            },
        });
    };

    onSearchChange = (_search) => {
        console.info("onSearchChange _search", _search);
        this.setState({ filter: _search });
    };

    saveFormRef = (formRef) => {
        this.formRef = formRef;
    };

    paginationSetPage = (_page) => {
        console.info("paginationSetPage _page", _page);
        this.setState({ pagination_currentPage: _page });
    };

    getListingDataSource = () => {
        let results = this.props.store.getAllCompetitors.filter((c) => {
            return (
                c.name
                    .toUpperCase()
                    .indexOf(this.state.filter.toUpperCase()) !== -1
            );
        });

        // --- sorting ---
        results.sort((a, b) => {
            //console.info("results.sort (this.state.sortby)", this.state.sortby);

            var nameA = a.name.toLowerCase(),
                nameB = b.name.toLowerCase();
            var brandA = a.brand ? a.brand.toLowerCase() : "",
                brandB = b.brand ? b.brand.toLowerCase() : "";

            switch (this.state.sortby) {
                case "name":
                    if (this.state.sortasc === true) {
                        if (nameA <= nameB) return -1;
                        if (nameA > nameB) return 1;
                    } else {
                        if (nameA <= nameB) return 1;
                        if (nameA > nameB) return -1;
                    }
                    break;
                case "brand":
                    if (this.state.sortasc === true) {
                        if (brandA <= brandB) return -1;
                        if (brandA > brandB) return 1;
                    } else {
                        if (brandA <= brandB) return 1;
                        if (brandA > brandB) return -1;
                    }
                    break;
                default:
                    return 0;
            }
            return 0;
        });
        // --- end of sorting

        return results.slice(
            (this.state.pagination_currentPage - 1) * config.PAGINATION_PERPAGE,
            this.state.pagination_currentPage * config.PAGINATION_PERPAGE
        );
    };

    render() {
        const competitorsLength = this.props.store.getAllCompetitorsLength;

        const pagesCount = competitorsLength / config.PAGINATION_PERPAGE;
        //console.log("pagesCount = " + pagesCount);

        const header = (
            <SocialListHeader
                title="Competitors"
                newButtonClickHandle={this.showModal}
                newButtonText="New competitor"
                newButtonTooltip={tooltips.COMPETITORS.NEWBUTTON}
                bulk={this.listBulk}
                searchChangeHandle={this.onSearchChange}
            />
        );

        let body =
            competitorsLength === 0 ? (
                <Empty />
            ) : (
                <List
                    size="small"
                    className="CompetitorsList"
                    header={
                        <Fragment>
                            {/* <Row type="flex" justify="space-between">
                                <Col
                                    style={{
                                        minWidth: 25,
                                        lineHeight: 1.2,
                                    }}
                                >
                                    <Checkbox
                                        // onChange={e => this.handleBulkAll(e)}
                                        onChange={(e) =>
                                            this.listBulk.handleAll(
                                                e.target.checked
                                            )
                                        }
                                        style={{ marginRight: 10 }}
                                    />
                                    {this.listBulk &&
                                        this.listBulk.renderOptionsAsList()}
                                </Col>
                                <Col>
                                    <Search
                                        placeholder="filter"
                                        onSearch={this.onSearchChange}
                                        onChange={(e) =>
                                            this.onSearchChange(e.target.value)
                                        }
                                        style={{ width: 200 }}
                                    />
                                </Col>
                            </Row> */}
                            <Row
                                style={{
                                    marginTop: 10,
                                    fontSize: 12,
                                    display: "flex",
                                    flex: "1 1",
                                    flexAlign: "start",
                                    alignItems: "flex-start",
                                }}
                            >
                                <Col style={{ width: 25, lineHeight: 1.2 }}>
                                    {/* <Checkbox
                                        // onChange={e => this.handleBulkAll(e)}
                                        onChange={(e) =>
                                            this.listBulk.handleAll(
                                                e.target.checked
                                            )
                                        }
                                    /> */}
                                </Col>
                                <Col style={{ flex: "1 1", marginRight: -30 }}>
                                    <SocialListColumn
                                        sortkey="name"
                                        sortby={this.state.sortby}
                                        sortasc={this.state.sortasc}
                                        handleSorting={this.setSorting}
                                    >
                                        Competitor name
                                    </SocialListColumn>
                                </Col>
                                <Col style={{ flexGrow: 1 }}>
                                    <SocialListColumn
                                        sortkey="brand"
                                        sortby={this.state.sortby}
                                        sortasc={this.state.sortasc}
                                        handleSorting={this.setSorting}
                                    >
                                        Brand
                                    </SocialListColumn>
                                </Col>
                                <Col style={{ width: 90 }}>Tools</Col>
                            </Row>
                        </Fragment>
                    }
                    footer={
                        pagesCount > 1 && this.state.filter.length === 0 ? (
                            <div style={{ textAlign: "right" }}>
                                <Pagination
                                    size="small"
                                    defaultCurrent={1}
                                    total={competitorsLength}
                                    pageSize={config.PAGINATION_PERPAGE}
                                    current={this.state.pagination_currentPage}
                                    onChange={this.paginationSetPage}
                                />
                            </div>
                        ) : null
                    }
                    bordered
                    dataSource={this.getListingDataSource()}
                    renderItem={(item, itemIndex) => (
                        <List.Item
                            key={itemIndex}
                            className={
                                this.listBulk &&
                                this.listBulk.isChecked(item.key)
                                    ? this.listBulk.getCheckedLength() === 1
                                        ? "social_Selected_withTools"
                                        : "social_Selected"
                                    : null
                            }
                            actions={[
                                <Tooltip
                                    key="edit"
                                    title={tooltips.COMPETITORS.LIST_EDIT}
                                    mouseEnterDelay={
                                        tooltips.SETTINGS.mouseEnterDelay
                                    }
                                >
                                    <Button
                                        type="link"
                                        style={{ padding: 0 }}
                                        onClick={(_evt) => {
                                            this.showModalForEdit(_evt, item);
                                        }}
                                    >
                                        <Icon type="edit" />
                                    </Button>
                                </Tooltip>,
                                <Tooltip
                                    key="delete"
                                    title={tooltips.COMPETITORS.LIST_DELETE}
                                    mouseEnterDelay={
                                        tooltips.SETTINGS.mouseEnterDelay
                                    }
                                >
                                    <Icon
                                        type="delete"
                                        onClick={(evt) => {
                                            this.handleDeleteCompetitor(
                                                evt,
                                                item
                                            );
                                        }}
                                        style={{
                                            color: scss_variables.scss_color_pallete_error,
                                        }}
                                    />
                                </Tooltip>,
                            ]}
                        >
                            <List.Item.Meta
                                title={
                                    <div key={item.name}>
                                        <Checkbox
                                            onChange={(e) =>
                                                this.listBulk.handleCheck(
                                                    item.key
                                                )
                                            }
                                            checked={
                                                this.listBulk
                                                    ? this.listBulk.isChecked(
                                                          item.key
                                                      )
                                                    : false
                                            }
                                            style={{ marginRight: 10 }}
                                        />
                                        {item.name}
                                    </div>
                                }
                            />
                            <div style={{ flexGrow: 1, textAling: "right" }}>
                                {item.brand}
                            </div>
                        </List.Item>
                    )}
                />
            );

        return (
            <Fragment>
                {header}
                {body}
                <CompetitorsListModal
                    data={this.state.edit_data}
                    store={this.props.store}
                />
            </Fragment>
        );
    }
}

export default observer(CompetitorsList);
